// Hook partagé : fetch sécurisé avec auth Bearer + cookie + tenant.
// Tous les widgets Finance l'utilisent. credentials:"include" + Bearer
// (le backend accepte les deux schémas d'auth, cf. AuthContext).
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

function getTenant() {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return user?.tenant_id || user?.tenant?.slug || "tef";
  } catch {
    return "tef";
  }
}

export function useFinanceFetch(url, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!url) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("session_token");
    const headers = {
      "X-Tenant-ID": getTenant(),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    fetch(`${API}${url}`, { headers, credentials: "include" })
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(String(e.message || e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, deps);

  return { data, loading, error };
}

// Helper formattage € (FR)
export function formatEuro(value, { compact = false } = {}) {
  const n = Number(value || 0);
  if (compact && Math.abs(n) >= 1000) {
    return `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k €`;
  }
  return n.toLocaleString("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });
}
